import { useEffect, useCallback, useRef, useState } from 'react';
import { Canvas, FabricObject } from 'fabric';
import { FABRIC_SERIALIZED_PROPERTIES } from '../constants/fabric-serialization';

/**
 * Creates and manages the Fabric.js Canvas instance lifecycle.
 * Dimensions and fitting are handled by useCanvasFit (called after layout load).
 */
export const useCanvas = (canvasRef: React.RefObject<HTMLCanvasElement | null>) => {
  const [canvas, setCanvas] = useState<Canvas | null>(null);
  const canvasInstanceRef = useRef<Canvas | null>(null);

  const createCanvas = useCallback(() => {
    if (!canvasRef.current) return;

    if (canvasInstanceRef.current) {
      canvasInstanceRef.current.dispose();
    }

    const instance = new Canvas(canvasRef.current, {
      enableRetinaScaling: true,
      backgroundColor: '#fff'
    });

    FabricObject.customProperties = [...FABRIC_SERIALIZED_PROPERTIES.propertiesToInclude];
    instance.renderAll();

    canvasInstanceRef.current = instance;
    setCanvas(instance);
  }, [canvasRef]);

  useEffect(() => {
    createCanvas();

    return () => {
      canvasInstanceRef.current?.dispose();
      canvasInstanceRef.current = null;
      setCanvas(null);
    };
  }, [createCanvas]);

  return canvas;
};
